import { render } from "./LazyComponentLoader.vue?vue&type=template&id=76eabee9"
import script from "./LazyComponentLoader.vue?vue&type=script&lang=js"
export * from "./LazyComponentLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__